// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gNgC","actions":"styles_actions__2WWNh","error":"styles_error__607DM","message":"styles_message__3-2ZQ"};